import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  FormControl,
  IconButton,
  Input,
  List,
  ListIcon,
  ListItem,
  useToast,
} from "@chakra-ui/react";
import { ChangeEvent, Dispatch, SetStateAction, useEffect } from "react";
import { DressCode } from "../../../../utils/types/EventType";

interface CustomSelectNoFormProps {
  id: string;
  label: string;
  options: DressCode[] | undefined;
  inputValue: string;
  isDisabled: boolean;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>; // <- Ajoutez ceci
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSelect: (option: DressCode) => void;
  handleDelete: (option: DressCode) => void;
  handleOpenModal: (option: string) => void;
}
const CustomSelectModal: React.FC<CustomSelectNoFormProps> = ({
  id,
  label,
  options,
  inputValue,
  isDisabled,
  isOpen,
  setIsOpen,
  handleInputChange,
  handleSelect,
  handleDelete,
  handleOpenModal,
}) => {
  const toast = useToast();

  useEffect(() => {
    const handleDocumentClick = (event: any) => {
      if (isOpen && !event.target.closest(`#${id}`)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [isOpen, setIsOpen, id]);

  return (
    <Box id={id} position="relative" width="300px">
      <FormControl id={id}>
        <Input
          isDisabled={isDisabled}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setIsOpen(true)}
          placeholder={`Saisir ou sélectionner ${label} ...`}
          minWidth="300px"
        />
      </FormControl>
      {isOpen && (
        <List
          position="absolute"
          zIndex="dropdown"
          bg="white"
          boxShadow="sm"
          p="2"
          mt="2"
          borderRadius="md"
          width="100%"
        >
          {options?.map((option: DressCode) => (
            <ListItem
              key={option.name}
              py="1"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              transition="box-shadow 0.2s"
              _hover={{ boxShadow: "lg" }}
            >
              <Box
                sx={{ cursor: "pointer" }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleSelect(option);
                }}
              >
                {option.name}
              </Box>
              <IconButton
                aria-label="Supprimer"
                variant="outline"
                size="sm"
                icon={<DeleteIcon color="red" />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(option);
                }}
              />
            </ListItem>
          ))}
          {inputValue &&
            !options?.some((option) => option.name === inputValue) && (
              <ListItem
                mt="2"
                py="1"
                bg="gray.100"
                onClick={(event) => {
                  event.stopPropagation();
                  handleOpenModal(inputValue); // Changez ceci pour ouvrir la modal
                }}
                sx={{ cursor: "pointer" }}
                _hover={{ boxShadow: "lg" }}
              >
                <ListIcon as={AddIcon} boxSize={4} ml="2" />
                Ajouter "{inputValue}"
              </ListItem>
            )}
        </List>
      )}
    </Box>
  );
};

export default CustomSelectModal;
